import { projects } from './core.initialState.projects';

export const goldens: IGoldens = {
  g1: {
    id: 'g1',
    createdBy: '',
    createdAt: '',
    generatorId: '',
    sequence: 1,
    model: { ...projects.p1.models.m1 },
  },
};
